/**
 * Get a parameter from a query string
 *
 * @param {string} key
 * @string {string}
 */

const getFromRequest = function(key) {
  const name = new RegExp("[?&]" + encodeURIComponent(key) + "=([^&]*)").exec(
    window.location.search
  )
  if (name) {
    return decodeURIComponent(name[1])
  }
}

export default getFromRequest
